import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { LangDroplistComponent } from './lang-droplist/lang-droplist.component';

@NgModule({
  declarations: [LangDroplistComponent],
  imports: [CommonModule, SharedUiComponentsModule, TranslateModule, InlineSVGModule],
  exports: [TranslateModule, LangDroplistComponent],
})
export class LangComponentsModule {}
